module.exports = __webpack_public_path__ + "a77634eeb36d58ea9b1e9291f1f36087.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/MetaPro-Bold/MetaPro-Bold.ttf
// module id = 364
// module chunks = 0